import React from 'react'
import { Navigate } from 'react-router'
import { FetchError } from '../api/useGet'
import { ErrorMessage } from './ErrorMessage'

interface Props {
  urlToken?: string
  error?: FetchError
}

interface UnacceptedTerms {
  status: 'unaccepted_terms'
}

interface FailedAttempts {
  status: 'too_many_failed_attempts'
}

function termsUnaccepted(error: FetchError) {
  const data = error.data as UnacceptedTerms

  return data && data.status === 'unaccepted_terms'
}

function tooManyLoginAttempts(error: FetchError) {
  const data = error.data as FailedAttempts

  return data && data.status === 'too_many_failed_attempts'
}

function unauthorized(error: FetchError) {
  return error.status === 401
}

export const Error: React.FC<Props> = ({ error, urlToken }) => {
  let redirect = ''
  const params = new URLSearchParams(window.location.search)
  if (error) {
    if (termsUnaccepted(error)) {
      redirect = `/accept-terms`
      if (urlToken) {
        params.set('urlToken', urlToken)
      }
    } else if (tooManyLoginAttempts(error)) {
      redirect = '/verification-error'
    } else if (unauthorized(error)) {
      localStorage.removeItem('authenticated')
      redirect = `/verify/${urlToken || ''}`
    }
  }

  return redirect ? (
    <Navigate replace to={{ pathname: redirect, search: params.toString() }} />
  ) : (
    <ErrorMessage code={(error && error.status) || 0} />
  )
}
